import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    WDSButton,
    Section,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import cityToCityConfig from '../../../../config/c2c.locale';

import styles from './ReturnTripCTA.scss';

function ReturnTripCTA(props) {
    const {
        t,
        reverseLink = '',
    } = props;

    return (
        <Section color="grey">
            <div className={styles.root}>
                <Typography
                    align="center"
                    className={styles.title}
                    component="h2"
                    variant="h3"
                >
                    {t('returnTripTitle')}
                </Typography>
                <WDSButton
                    className={styles.button}
                    color="secondary"
                    component={A}
                    componentProps={{
                        href: reverseLink,
                        native: true,
                        underline: 'none',
                    }}
                >
                    {t('returnTripDescription')}
                </WDSButton>
            </div>
        </Section>
    );
}

ReturnTripCTA.propTypes = {
    reverseLink: PropTypes.string.isRequired,
};

export {
    ReturnTripCTA,
};

export default localize(ReturnTripCTA, cityToCityConfig.namespace);
